import { useOnboardingContext } from '@/contexts/onboardingContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';
import { defaultOptionTypes } from '@/ui/components/Form/Select/types';
import { focusClasses } from '@/ui/members/components/form/styles';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const RadioGroup = ({
  autoFocus = false,
  disabled = false,
  extraDetailsInput,
  helpText,
  id,
  label,
  onChange,
  options,
  optionsClassName = '',
  selectedValue
}: Props) => {
  const mixpanel = useMixpanel();
  const context = useOnboardingContext();

  const onChangeWithTrack = (value: defaultOptionTypes) => {
    onChange(value);
    mixpanel.trackRadioSelected(id, value, undefined, {
      version: context.version,
      feature: 'unified-onboarding'
    });
  };

  return (
    <fieldset className="font-roboto" disabled={disabled}>
      {label && (
        <legend className="block font-medium dark:text-uniform-gray-100 light:text-uniform-gray-900 tracking-tightest mb-2">
          {label}
        </legend>
      )}

      <div className={optionsClassName ? optionsClassName : 'grid gap-2'}>
        {options.map(({ className, label: optionLabel, subLabel, value }, index) => {
          const optionKey = `${id}-radio-${value}`;
          const checked = value === selectedValue;

          return (
            <div key={optionKey}>
              <div
                className={`flex items-center py-2 px-3 border ${checked ? 'bg-uniform-green-700 text-uniform-white-base' : 'dark:bg-uniform-gray-900 light:bg-uniform-white-base dark:text-uniform-white-base light:text-uniform-gray-900'}  border-uniform-gray-400 rounded-sm ${className}`}>
                <input
                  autoFocus={autoFocus ? index === 0 : false}
                  id={optionKey}
                  type="radio"
                  value={String(value)}
                  checked={checked}
                  onChange={() => onChangeWithTrack(value)}
                  className={`accent-uniform-green-700 h-4 w-4 ${focusClasses}`}
                />
                <label htmlFor={optionKey} className="ml-3 block grow">
                  <span className="flex flex-col">
                    <span className="text-lg font-bold">{optionLabel}</span>

                    {subLabel && <span className="text-base">{subLabel}</span>}
                  </span>
                </label>
              </div>

              {extraDetailsInput && checked && <div className="mt-1">{extraDetailsInput}</div>}
            </div>
          );
        })}
      </div>
      {helpText && <div className="mt-2 text-sm text-gray-500">{helpText}</div>}
    </fieldset>
  );
};

export default RadioGroup;
